import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../css/Header.css';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null); // Ref for the entire menu area

    const toggleMenu = (event) => {
        event.stopPropagation(); // Prevent the click event from propagating to the document
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    // Close menu when clicking outside
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    return (
        <header className="header">
            <div className="logo-container">
                <Link to="/">
                    <img src="/images/logo.png" alt="Cab Booking Logo" className="logo" />
                </Link>
            </div>
            {/* Wrap menu icon and navigation in a parent container */}
            <div ref={menuRef} className="menu-container">
                {/* Menu icon for mobile */}
                <div className="menu-icon" onClick={toggleMenu}>
                    <span className="menu-bar"></span>
                    <span className="menu-bar"></span>
                    <span className="menu-bar"></span>
                    <span className="menu-bar"></span>
                </div>
                {/* Desktop view: Always visible, mobile view: Toggle visibility */}
                <nav className={`navigation ${menuOpen ? 'show' : ''} ${window.innerWidth <= 768 ? 'mobile' : ''}`}>
                    <ul className={`nav-list${menuOpen ? 'show' : ''} ${window.innerWidth <= 768 ? '.mobile' : ''}`}>
                        <li className="nav-item">
                            <Link to="/" onClick={closeMenu}>Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/traffic" onClick={closeMenu}>Traffic</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/contact-us" onClick={closeMenu}>Contact Us</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/account" onClick={closeMenu}>Account</Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
